import React, { PureComponent } from 'react';
import LabeledField from 'c/CalculationLayer/utils/LabeledField';
import modalStyl from 'c/CalculationLayer/Modal/index.styl';
import TripletHolder from 'c/CalculationLayer/utils/TripletHolder';
import { UnitsInputv2 } from 'c/CalculationLayer/utils/UnitsInputv2';
import { connect } from 'react-redux';
import { IntInput, Props as IntProps } from 'c/CalculationLayer/utils/IntInput';
import { batchActions } from 'redux-batched-actions';
import { unitMapping } from 'scr/metricsConversion';

type tall = redux.store['projectFor3d']['cabinetsSettings']['tall'];
type a = redux.actions;

type labelActionTypes = a['setCabinetsSettingsTallDepthLabel']['type'] |
  a['setCabinetsSettingsTallHeightLabel']['type'];

type valueActionTypes = a['setCabinetsSettingsTallDepthValue']['type'] |
a['setCabinetsSettingsTallHeightValue']['type']

type batchAction = redux.batchActionsWithTempl<
  a['setCabinetsSettingsTallDepthLabel'] |
  a['setCabinetsSettingsTallDepthValue'] |
  a['setCabinetsSettingsTallHeightLabel'] |
  a['setCabinetsSettingsTallHeightValue'] |
  a['setCabinetsSettingsTallShelvesQty']
>;

interface Props {
  units: redux.store['projectFor3d']['units'];
  height: tall['height'];
  depth: tall['depth'];
  shelvesQty: tall['shelvesQty'];
  dispatch: redux.d<ReturnType<batchAction>>;
}

export const Tall = connect(
  ( {
    projectFor3d: {
      units,
      cabinetsSettings: { tall }
    }
  }: redux.store ): Omit<Props, 'dispatch'> => ( {
    units,
    height: tall.height,
    depth: tall.depth,
    shelvesQty: tall.shelvesQty
  } )
)(
  class Tall extends PureComponent<Props> {
    changeMetric = (
      labelAction: labelActionTypes,
      valueAction: valueActionTypes
    ) => ( value: UnitsInputv2Value ) => {
      const { units, dispatch } = this.props;

      const val = units === 'ftAndInch'
        ? unitMapping.ftAndInch( value )
        : unitMapping[ units ]( Number( value ) );

      dispatch(
        ( batchActions as batchAction )( [
          { type: labelAction, value },
          { type: valueAction, value: val }
        ] )
      );
    }

    changeQty = ( n: number ) => {
      this.props.dispatch(
        ( batchActions as batchAction )( [
          {
            type: 'SET_CABINETS_SETTINGS_TALL_SHELVES_QTY',
            value: n as quantity
          }
        ] )
      );
    }

    render() {
      const {
        props: {
          units,
          height: { label: hLabel },
          shelvesQty,
          depth: { label: dLabel }
        },
        changeMetric,
        changeQty
      } = this;

      return (
        <LabeledField
          className={
            `${ modalStyl.commonLabeledField } wider` +
          ' shortLabel label100px fontSize14px'
          }
          name='Tall cabinet'
        >
          <TripletHolder>
            <UnitsInputv2
              units={ units }
              value={ hLabel }
              onChange={ changeMetric(
                'SET_CABINETS_SETTINGS_TALL_HEIGHT_LABEL',
                'SET_CABINETS_SETTINGS_TALL_HEIGHT_VALUE'
              ) }
              className={ modalStyl.commonInput }
            />
            <UnitsInputv2
              units={ units }
              value={ dLabel }
              onChange={ changeMetric(
                'SET_CABINETS_SETTINGS_TALL_DEPTH_LABEL',
                'SET_CABINETS_SETTINGS_TALL_DEPTH_VALUE'
              ) }
              className={ modalStyl.commonInput }
            />
            <IntInput
              value={
                shelvesQty as
                  baseOf<Props['shelvesQty']> as
                    IntProps['value']
              }
              onChange={ changeQty }
              className={ modalStyl.commonInput }
            />
          </TripletHolder>
        </LabeledField>
      );
    }
  }
);
